import clsx from "clsx";
import React, { useEffect, useState } from "react";
import ModernDrawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import { useBreakpoints, useTheme } from "../../hooks";
import { Icon } from "../icon";

export type DrawerDirections = "left" | "right" | "top" | "bottom";

type DrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  size?: string | number;
  direction?: DrawerDirections;
  bodyClassName?: string;
  className?: string;
};

const Drawer: React.FC<React.PropsWithChildren<DrawerProps>> = ({
  children,
  isOpen,
  onClose,
  size,
  direction = "right",
  bodyClassName = "p-2",
  className,
}) => {
  const { Theme } = useTheme();
  const { isMobile } = useBreakpoints();
  const [localSize, setLocalSize] = useState<string | number>(250);

  useEffect(() => {
    if (!!size) {
      setLocalSize(size);
    } else if (isMobile) {
      setLocalSize("100%");
    } else {
      setLocalSize(250);
    }
  }, [isMobile, size]);

  return (
    <ModernDrawer
      open={isOpen}
      onClose={onClose}
      size={localSize}
      direction={direction}
      className={className}
      enableOverlay={true}
      overlayOpacity={0}
    >
      <div className={clsx(bodyClassName)}>
        <div className="float-end mx-2">
          <Icon iconName="fa-times" styles={{ ...Theme.icon, size: "1.4rem" }} onClick={onClose} />
        </div>
        {children}
      </div>
    </ModernDrawer>
  );
};

export default Drawer;
